import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  profileActions as sharedProfileActions,
  tSharedAppDispatch
} from 'common/modules/ReactShared';
import { settingsApi } from 'students/api';

const uploadProfilePhoto = createAsyncThunk<
  void,
  File,
  {
    dispatch: tSharedAppDispatch;
  }
>('profile/uploadPhoto_request', async (photo, { dispatch }) => {
  const { data } = await settingsApi.uploadFile(photo);

  dispatch(sharedProfileActions.updateProfile({ avatar: data }));
});

export const profileActions = { ...sharedProfileActions, uploadProfilePhoto };
